/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SessionCount
 */
export interface SessionCount {
    /**
     * for debugging. The raw db row timestamp.
     * @type {Date}
     * @memberof SessionCount
     */
    rowValueUtc?: Date;
    /**
     * The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00`
     * @type {Date}
     * @memberof SessionCount
     */
    timestamp?: Date;
    /**
     * Date label, to avoid timezone conversions in frontend. eg:
     * Hour: yyyy-MM-ddTHH:00:00
     * Day: yyyy-MM-dd
     * Week: 2022W01 (week-of-year, new weeks start on Sunday)
     * Month: 2022M01
     * @type {string}
     * @memberof SessionCount
     */
    label?: string;
    /**
     * The number of sessions that started in this interval
     * @type {number}
     * @memberof SessionCount
     */
    count?: number;
}

/**
 * Check if a given object implements the SessionCount interface.
 */
export function instanceOfSessionCount(value: object): value is SessionCount {
    return true;
}

export function SessionCountFromJSON(json: any): SessionCount {
    return SessionCountFromJSONTyped(json, false);
}

export function SessionCountFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SessionCount {
    if (json == null) {
        return json;
    }
    return {
        rowValueUtc:
            json["rowValueUtc"] == null
                ? undefined
                : new Date(json["rowValueUtc"]),
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        label: json["label"] == null ? undefined : json["label"],
        count: json["count"] == null ? undefined : json["count"],
    };
}

export function SessionCountToJSON(value?: SessionCount | null): any {
    if (value == null) {
        return value;
    }
    return {
        rowValueUtc:
            value["rowValueUtc"] == null
                ? undefined
                : value["rowValueUtc"].toISOString(),
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        label: value["label"],
        count: value["count"],
    };
}
